import {Component, inject, signal} from '@angular/core';
import {ButtonComponent, NewArtworkFormComponent, RightContainerComponent, ToastService} from "@components";
import {TranslocoDirective} from "@jsverse/transloco";
import {ModalComponent} from '@easy-cms'
import {ArtworkService} from "@api-services";
import {AuthenticationService} from "@services";
import {rxResource} from "@angular/core/rxjs-interop";
import {CurrencyPipe} from "@angular/common";
import {MediaRenderComponent} from "@components";
import {TimesIconComponent, TrashIconComponent, PencilRuleIconComponent} from "@icons";
import {ArtworkDto} from "@api-contracts";
import { map } from 'rxjs';

@Component({
  selector: 'wun-user-artworks',
  imports: [
    NewArtworkFormComponent,
    ModalComponent,
    ButtonComponent,
    TranslocoDirective,
    CurrencyPipe,
    MediaRenderComponent,
    RightContainerComponent,
    TrashIconComponent,
    TimesIconComponent,
    PencilRuleIconComponent
  ],
  templateUrl: './user-artworks.component.html',
  styleUrl: './user-artworks.component.scss'
})
export class UserArtworksComponent {
  show = signal(false);
  private readonly artworkService = inject(ArtworkService);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly toastService = inject(ToastService);
  myArtworks = rxResource({
    params: () => this.authenticationService.current(),
    stream: (params) => {
      return this.artworkService.artworksFindAndPaginate({
        pageSize: 1000,
        filters: JSON.stringify({
          artist: params.params.id
        }),
        includes: JSON.stringify(['mainAttachment', "attachments"])
      }).pipe(map(d =>  {
        return {
          ...d,
          data: d.data.filter(x => x.mainAttachment)
        }
      }))
    }
  })
  askDeleteArtwork = signal(false);
  selectedArtwork = signal<ArtworkDto | undefined>(undefined)
  showEdit = signal(false);
  artworkToEdit = signal<ArtworkDto | undefined>(undefined);

  selectToBeDeleted(artwork: ArtworkDto) {
    this.askDeleteArtwork.set(true);
    this.selectedArtwork.set(artwork)
  }

  openEdit(artwork: ArtworkDto) {
    this.artworkToEdit.set(artwork);
    this.showEdit.set(true);
  }

  deleteArtwork() {
    this.artworkService.artworksDelete({
      id: this.selectedArtwork()!.id
    }).subscribe(d => {
      this.selectedArtwork.set(undefined);
      this.askDeleteArtwork.set(false);
      this.myArtworks.reload()
    })
  }

  createNewArtwork() {
    if(!this.authenticationService.hasSubscription())
      this.toastService.addMessage({
        severity: 'error',
        title: 'common.subscriptionRequired'
      })
    else this.show.set(true)
  }
}
